import React, {
  useState,
  useLayoutEffect,
  useEffect,
  lazy,
  Suspense,
} from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import loadable from "@loadable/component";
import AOS from "aos";
import "aos/dist/aos.css";
import "mapbox-gl/dist/mapbox-gl.css";
//import BlogsCategory from "./container/blogs/blog-by-category/BlogsCategory";
//import Blog from "./container/blogs/blog-by-title/Blog";
import { EnquiryToastProvider } from "./contexts/enquiry-toast-context";
import { ErrorFallback } from "./components/ErrorHandler/ErrorHandler";
import Navbar from "./components/Navbar/Navbar";
//import HeaderFixed from "./components/HeaderFixed/HeaderFixed";
//import RouteChangeLoader from "./components/RouteChangeLoader/RouteChangeLoader";
// import Legal from "./pages/Legal";
// import Policy from "./container/legal-policy/policy/Policy";
import useNetwork from "./hooks/useNetwork";
//import NetworkError from "./components/NetworkError/NetworkError";
import useWindowDimensions from "./hooks/useWindowDimensions";
//import { getCookie, getPageName } from "./utils/utils";
import { deleteFcmToken, fetchToken, onMessageListener } from "./firebase";
//import NotificationToast from "./components/NotificationToast/NotificationToast";
import localforage from "localforage";
//import NotificationBar from "./components/NotificationBar/NotificationBar";
import Cookies from "js-cookie";
//import WorkspaceVisited from "./components/WorkspaceVisited/WorkspaceVisited";
import { PropertyProvider } from "./contexts/property-location";
//import { isSupported } from "firebase/messaging";
//import CookieBanner from "./components/CookieConsent/CookieBanner/CookieBanner";
import { isSupported } from "firebase/messaging";
import { ContactDetailsProvider } from "./contexts/contact-context";
import { UTMProvider } from "./contexts/utm-context";
import { Helmet } from "react-helmet-async";
// import GoogleTagManager from "./hooks/useGoogleTagManager";
//import NotFound from "./components/not-found/NotFound";
//import { ErrorBoundary } from "react-error-boundary";

//import Loader from "./components/Loader/Loader";

const Home = lazy(() => import(/* webpackChunkName: 'Home' */ "./pages/Home"));
const LocationSearch = lazy(() =>
  import(/* webpackChunkName: 'LocationSearch' */ "./pages/LocationSearch")
);
const Property = lazy(() =>
  import(/* webpackChunkName: 'Property' */ "./pages/Property")
);
const ContactUs = lazy(() => import("./pages/ContactUs"));
const CovidResponse = lazy(() => import("./pages/CovidResponse"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
// const StartupCredit = lazy(() => import("./pages/StartupCredit"));
// const LandlordPartnership = lazy(() => import("./pages/LandlordPartnership"));
//const Stories = lazy(() => import("./pages/Stories"));
const FreeTour = lazy(() => import("./pages/FreeTour"));
//const Sitemap = lazy(() => import("./pages/Sitemap"));
const Solutions = lazy(() => import("./pages/Solutions"));
const Spaces = lazy(() => import("./pages/Spaces"));
const Faqs = lazy(() => import("./pages/Faqs"));
const Legal = lazy(() => import("./pages/Legal"));
const Policy = lazy(() => import("./container/legal-policy/policy/Policy"));
const VirtualOffices = lazy(() => import("./pages/VirtualOffices"));
const VirtualOfficesAds2 = lazy(() => import("./pages/VirtualOfficesAds2"));
const DwarkaPage = lazy(() => import("./pages/DwarkaPage"));
//const AOS = loadable.lib(() => import("aos"));
// loadable.lib(() => import("aos/dist/aos.css"));
// loadable.lib(() => import("mapbox-gl/dist/mapbox-gl.css"));
const RouteChangeLoader = loadable(() =>
  import("./components/RouteChangeLoader/RouteChangeLoader")
);
const NotificationToast = loadable(() =>
  import("./components/NotificationToast/NotificationToast")
);
const HeaderFixed = loadable(() =>
  import("./components/HeaderFixed/HeaderFixed")
);
const NetworkError = loadable(() =>
  import("./components/NetworkError/NetworkError")
);
const CookieBanner = loadable(() =>
  import("./components/CookieConsent/CookieBanner/CookieBanner")
);
const NotificationBar = loadable(() =>
  import("./components/NotificationBar/NotificationBar")
);
const WorkspaceVisited = loadable(() =>
  import("./components/WorkspaceVisited/WorkspaceVisited")
);
const NotFound = loadable(() => import("./components/not-found/NotFound"));
const GoogleTagManager = loadable(() => import("./hooks/useGoogleTagManager"));
//const useNetwork = loadable(() => import("./hooks/useNetwork"));

const queryClient = new QueryClient();

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, [pathname]);

  return null;
}

function App() {
  const { pathname } = useLocation();
  const [routeChange, setRouteChange] = useState(false);
  const [show, setShow] = useState(false);
  const [pushNotify, setPushNofify] = useState(false);
  const [isVisited, setIsVisited] = useState(false);
  const [visitedData, setVisitedData] = useState({});
  const [notification, setNotification] = useState({
    title: "",
    body: "",
    action: "",
    imgUrl: "",
  });
  const [loading, setLoading] = useState(false);
  const { width } = useWindowDimensions();

  const { online } = useNetwork();

  useEffect(() => {
    const interval = setInterval(() => {
      setLoading(false);
      setRouteChange(false);
    }, 500);
    return () => {
      clearInterval(interval);
    };
  }, [routeChange]);

  useLayoutEffect(() => {
    if (
      // pathname !== "/free-tour" &&
      // !pathname.includes("/locations/") &&
      // !pathname.includes("/ads/")
      pathname === "/"
    ) {
      setRouteChange(true);
      setLoading(true);
    }
  }, [pathname]);

  useEffect(() => {
    if (AOS) {
      AOS.init();
      AOS.refresh();
    }
  }, []);

  // useEffect(() => {
  //   window.analytics.page(getPageName(pathname), {
  //     path: getPageName(pathname),
  //     url: window.location.href,
  //   });
  //   let ck = getCookie("ajs_user_id");

  //   if (!ck) {
  //     window.analytics.ready(function () {
  //       let userId = window.analytics.user().anonymousId();
  //       window.analytics.identify(userId);
  //     });
  //   }
  // }, [pathname]);

  onMessageListener()
    .then((payload) => {
      setNotification({
        title: payload.data.heading,
        body: payload.data.subheading,
        imgUrl: payload.data?.img,
        action: payload.data.url,
      });
      setShow(true);
      //console.log(payload);
    })
    .catch((err) => console.log("failed: ", err));

  async function createLocalToken() {
    const tokenInLocalForage = await localforage.getItem("fcm_token");
    //console.log("token in local", tokenInLocalForage);

    // Return the token if it is alredy in our local storage
    if (tokenInLocalForage !== null) {
      setPushNofify(false);
      return tokenInLocalForage;
    }

    // If there is no token then get token
    if (!tokenInLocalForage) {
      fetchToken();
    }
  }

  const clearLocalToken = async () => {
    const tokenInLocalForage = await localforage.getItem("fcm_token");
    if (tokenInLocalForage) {
      await deleteFcmToken(tokenInLocalForage);
      localforage.removeItem("fcm_token");
    }
    if (
      (!tokenInLocalForage && sessionStorage.getItem("notify") === false) ||
      sessionStorage.getItem("notify") === null
    ) {
      setPushNofify(true);
    }
  };

  async function fcm() {
    let supported = await isSupported();
    if (supported) {
      let areNotificationsAllowed =
        Notification && Notification.permission === "granted";

      if (areNotificationsAllowed) {
        setPushNofify(false);
        createLocalToken();
      } else {
        setPushNofify(true);
        clearLocalToken();
      }
    } else {
      console.log("Not supported fcm");
    }
  }

  useEffect(() => {
    let timeout;

    timeout = setTimeout(() => {
      fcm();
    }, 25000);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // to get data from cookie about property
  useEffect(() => {
    let cdata = Cookies.get("workspace_visited");
    if (cdata) {
      setVisitedData(JSON.parse(cdata));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  // detect route change and show workspace stored in cookies after 15 sec
  useEffect(() => {
    setIsVisited(false);
    let timeout = setTimeout(() => {
      if (
        Object.keys(visitedData).length !== 0 &&
        !pathname.includes(`/locations/`) &&
        pathname !== "/free-tour"
      ) {
        setIsVisited(true);
      } else {
        setIsVisited(false);
      }
    }, 20000);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, visitedData.place]);

  // to show cookies banner
  const [cBanner, setCBanner] = useState(false);
  useEffect(() => {
    let timeout;
    let cookiePermission = Cookies.get("permission");
    if (cookiePermission === undefined || cookiePermission === null) {
      timeout = setTimeout(() => {
        setCBanner(true);
      }, 20000);
    } else {
      setCBanner(false);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);

  // detect add pages
  const [adsPage, setAdsPage] = useState(false);
  useEffect(() => {
    if (pathname.includes("/ads/")) {
      setAdsPage(true);
    }
  }, [pathname]);

  // to test white screen error
  // const navigate = useNavigate();
  // const arr = ["/solutions", "/"];
  // const [counter, setCounter] = useState(0);
  // useEffect(() => {
  //   let tim = setTimeout(() => {
  //     // console.log("timeout runs");
  //     setCounter((c) => c + 1);

  //     arr.map((loc) => {
  //       console.log(counter);
  //       return navigate(loc);
  //     });
  //   }, 2000);

  //   return () => clearTimeout(tim);
  // }, [counter]);

  return (
    <>
      <Helmet>
        <link rel="canonical" href={`https://www.workingdom.in${pathname}`} />
      </Helmet>

      <QueryClientProvider client={queryClient}>
        <GoogleTagManager gtmId="GTM-KGFBPDF" />

        <UTMProvider>
          <ContactDetailsProvider>
          {width > 500 && routeChange && <RouteChangeLoader open={loading} />}
          <NetworkError show={!online} />
          {!adsPage && pushNotify && (
            <NotificationBar setPushNotify={setPushNofify} />
          )}
          {!adsPage && show && (
            <NotificationToast
              data={notification}
              autoDelete
              show={show}
              setShow={setShow}
            />
          )}
          {!adsPage && isVisited && (
            <PropertyProvider>
              <WorkspaceVisited
                data={visitedData}
                setIsVisited={setIsVisited}
                isVisited={isVisited}
              />
            </PropertyProvider>
          )}
          {!adsPage && cBanner && <CookieBanner setCBanner={setCBanner} />}
          <ScrollToTop />

          <EnquiryToastProvider>
            <HeaderFixed>
              <Suspense
                fallback={
                  width > 500 ? <RouteChangeLoader open={loading} /> : <></>
                }
              >
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route
                    path="/locations"
                    element={<Navigate to="/locations/all" replace />}
                  />
                  <Route
                    path="/locations/:place"
                    element={<LocationSearch />}
                  />
                  <Route
                    path="/locations/:place/:slug"
                    element={<Property />}
                  />
                  <Route path="/contact-us" element={<ContactUs />} />
                  <Route path="/solutions" element={<Solutions />} />
                  <Route path="/covid-response" element={<CovidResponse />} />
                  <Route path="/about-us" element={<AboutUs />} />
                  {/* <Route path="/startup-credits" element={<StartupCredit />} />
              <Route path="/partnerships" element={<LandlordPartnership />} /> */}
                  {/* <Route path="stories" element={<Stories />}>
                <Route
                  index
                  element={
                    <main style={{ padding: "1rem" }}>
                      <p>Select category</p>
                    </main>
                  }
                />
                <Route path=":category" element={<BlogsCategory />}></Route>
              </Route>
              <Route path="stories/:category/:title" element={<Blog />} /> */}
                  <Route path="/free-tour" element={<FreeTour />} />
                  <Route path="/faq" element={<Faqs />} />
                  <Route path="/virtual-office" element={<VirtualOffices />} />
                  <Route path="/ads/:place" element={<Spaces />} />
                  <Route
                    path="/ads/delhi/:place_name"
                    element={<DwarkaPage />}
                  />
                  <Route
                    path="ads/virtual-office"
                    element={<VirtualOffices />}
                  />
                  <Route
                    path="ads/virtual-office-2"
                    element={<VirtualOfficesAds2 />}
                  />
                  <Route path="legal" element={<Legal />}>
                    <Route
                      index
                      element={<Navigate to="/legal/privacy-policy" replace />}
                    />
                    <Route path=":action" element={<Policy />}></Route>
                  </Route>
                  <Route
                    path="*"
                    element={
                      <>
                        <Navbar />
                        <NotFound />
                      </>
                    }
                  />
                </Routes>
              </Suspense>
            </HeaderFixed>
          </EnquiryToastProvider>
        </ContactDetailsProvider>
        </UTMProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
